// extracted by mini-css-extract-plugin
var _1 = "AdminAppearanceView-module__badgeContainer--bwQBV";
var _2 = "AdminAppearanceView-module__field--t92MS";
var _3 = "AdminAppearanceView-module__fieldContainer--kCA0v";
var _4 = "AdminAppearanceView-module__title--L2ste";
export { _1 as "badgeContainer", _2 as "field", _3 as "fieldContainer", _4 as "title" }
